import ACTION_TYPES from "./type.action";

export const showError = errorMessage => {
  return { type: ACTION_TYPES.GOT_ERROR, payload: errorMessage };
};

export const clearError = () => {
  return { type: ACTION_TYPES.CLEAR_ERROR, payload: "" };
};
